import { queryOptions, useQuery } from '@tanstack/react-query'
import { dashboardClient } from '@/api'
import { useParams } from 'react-router-dom'

export const pageQueryOptions = (companyId: string, gameId: string, pageId: string) =>
  queryOptions({
    queryKey: ['pages', gameId, pageId],
    queryFn: () => dashboardClient.v1.getPage(companyId, gameId, pageId),
    select: response => response.data,
  })

export const usePageQuery = (pageId: string, opts: { enabled?: boolean } = {}) => {
  const { companyId, gameId } = useParams() as { companyId: string; gameId: string }
  return useQuery({ ...pageQueryOptions(companyId, gameId, pageId), ...opts })
}
